const cidFileStatus = {
  REQUESTED: 'REQUESTED',
  PROCESSING: 'PROCESSING',
  AVAILABLE: 'AVAILABLE',
  ERROR: 'ERROR'
};

module.exports = cidFileStatus;
